import React, { useState } from 'react';

import { Button, Dialog, DialogContent, DialogTitle, Typography } from 'components/AORedesign';
import { redirectUrlFunction } from '../CommonUtilityServices/RedirectService';
import WorkflowCard from './WorkflowCard';

const WorkflowCardQuickQuote = () => {
  const [showEnvModal, setShowEnvModal] = useState(false);

  const isDev = import.meta.env.REACT_APP_ENV === 'dev';

  const handleQuickQuoteRedirect = (targetEnv) => {
    const detailedContext = [
      {
        name: 'quoteType',
        value: 'QuickQuote',
      },
    ];

    if (targetEnv) {
      detailedContext.push({
        name: 'targetEnvironment',
        value: targetEnv,
      });
    }

    redirectUrlFunction(
      {
        Area: 'Relate Quick Quote',
        DetailedContext: detailedContext,
        TypeOfRedirect: 'Relate Quick Quote',
      },
      'POST',
      null,
      () => { },
      () => { },
    );
  };

  const handleOnClick = () => {
    if (isDev) {
      setShowEnvModal(true);
    } else {
      handleQuickQuoteRedirect();
    }
  };

  return (
    <>
      <WorkflowCard
        onClick={handleOnClick}
        icon={'icons-icon-request-quote'}
        title="Quick Quote"
        description="Start a quick quote for your client's insurance needs."
      />

      <Dialog
        open={showEnvModal}
        onClose={() => setShowEnvModal(false)}
        aria-labelledby="relate-env-dialog-title"
      >
        <DialogTitle>
          <Typography variant="h4">Select Relate Environment</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography style={{ marginBottom: 16 }}>Choose the Relate Community environment for testing:</Typography>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowEnvModal(false);
                handleQuickQuoteRedirect('partnercom');
              }}
            >
              Partnercom (Sandbox)
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setShowEnvModal(false);
                handleQuickQuoteRedirect('devint');
              }}
            >
              DevInt (Integration)
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default WorkflowCardQuickQuote;